<script>
  import Project from "./Project.svelte";
  import Tech from "./Tech.svelte";
  import { GoogleAnalytics } from '@beyonk/svelte-google-analytics';

  const tech = {
    "cats": {
      name: "Typelevel Cats",
      url: "https://typelevel.org/cats/",
    },
    "react": {
      name: "React",
      url: "https://www.react.com",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png",
    },
    "scala": {
      name: "Scala",
      url: "https://www.scala-lang.org",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Scala-full-color.svg/1200px-Scala-full-color.svg.png",
    },
    "android": {
      name: "Android",
      url: "https://www.android.com",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Android_robot.svg/1200px-Android_robot.svg.png",
    },
    "play": {
      name: "Playframework",
      url: "https://www.playframework.com",
    },
    "spray": {
      name: "Spray",
      url: "https://www.spray.io",
    },
    "typescript": {
      name: "TypeScript",
      url: "https://www.typescriptlang.org",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/1200px-Typescript_logo_2020.svg.png",
    },
    "flow": {
      name: "Flow",
      url: "https://www.flow.org",
    },
    "node": {
      name: "Node",
      url: "https://www.nodejs.org ",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/1200px-Node.js_logo.svg.png",
    },
    "akkahttp": {
      name: "Akka Http",
      url: "https://akka.io",
    },
    "ziohttp": {
      name: "ZIO Http",
      url: "https://zio.dev",
      iconUrl: "https://zio.dev/img/navbar_brand.png",
    },
    "postgres": {
      name: "Postgres",
      url: "https://www.postgresql.org",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/1200px-Postgresql_elephant.svg.png",
    },
    "mongodb": {
      name: "Mongo",
      url: "https://www.mongodb.com",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/MongoDB_Logo.svg/1200px-MongoDB_Logo.svg.png",
    },
    "amazon": {
      name: "Amazon",
      url: "https://www.amazon.com",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Amazon.com-Logo.svg/1200px-Amazon.com-Logo.svg.png",
    },
    "vercel": {
      name: "Vercel",
      url: "https://www.vercel.com",
    },
    "reactnative": {
      name: "React Native",
      url: "https://reactnative.dev",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png",
    },
    "svelte": {
      name: "Svelte",
      url: "https://svelte.dev",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Svelte_Logo.svg/1200px-Svelte_Logo.svg.png",
    },
    "scalajs":{
      name: "Scala.js",
      url: "https://www.scala-js.org",
      iconUrl: "https://www.scala-js.org/assets/img/scala-js-logo.svg",
    },
    "java": {
      name: "Java",
      url: "https://www.java.com",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Java_Logo.svg/1200px-Java_Logo.svg.png",
    },
    "documentum": {
      name: "EMC Documentum",
      url: "https://www.opentext.com/products/documentum-content-management"
    },
    "kotlin": {
      name: "Kotlin",
      url: "https://kotlinlang.org",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Kotlin-logo.svg/1200px-Kotlin-logo.svg.png",
    },
    "mssql": {
      name: "SQL Server",
      url: "https://www.microsoft.com/en-us/sql-server",
      iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_SQL_Server_Logo.svg/1200px-Microsoft_SQL_Server_Logo.svg.png",
    },
  }

  const domains = [
    {
      name: "E-learning",
      projects: [
        {
          name: "Ucourse",
          url: "https://startersquad.com/startups/ucourse/",
          iconUrl: "https://images.ctfassets.net/toma43wx0449/3oyyy5W0ZZ723InGtE0jbZ/02c6bf9f00b57a9c8825a65aaa56f3b4/Ucourse.png?w=256&q=50&fit=fill&f=face&fm=webp",
          description: "is a new e-learning platform for even better online courses",
          stack: [
            tech.react,
            tech.scala,
            tech.spray,
          ],
          roles: ["developer"]
        },
      ],
    },
    {
      name: "Gaming",
      projects: [
        {
          name: "musear",
          url: "https://musear-platform.com/",
          //iconUrl: "https://musear-platform.com/wp-content/uploads/2022/12/logo-musear.svg",
          description: "is the best way to promote your cultural heritage through digital media.",
          stack: [
            tech.react,
            tech.typescript,
          ],
          roles: ["developer"]
        }
      ]
    },
    {
      name: "Android",
      projects: [
        {
          name: "Troido",
          url: "https://troido.de/",
          description: "is building apps and digital solutions for businesses and industries with our impactful solutions for iOS and Android, IoT, BLE.",
          stack: [
            tech.android,
            tech.java,
          ],
          roles: ["developer"]
        }
      ]
    },
    {
      name: "Manufacturing",
      projects: [
        {
          name: "Parsley",
          url: "https://www.parsleysoftware.com/",
          iconUrl: "https://www.parsleysoftware.com/wp-content/themes/parsley/public/logo.svg",
          description: "is a kitchen management intuitive app that helps you manage your culinary operations, saves you time, reduces costs, and increases efficiency.",
          stack: [
            tech.react,
            tech.flow,
            tech.scala,
            tech.play,
          ],
          roles: ["developer"]
        },
        {
          name: "Swipeguide",
          url: "https://www.swipeguide.com/",
          description: "is a digital work instruction software that enables companies to create visual and step-by-step digital work instructions - hassle-free.",
          stack: [
            tech.react,
            tech.node,
            tech.typescript,
          ],
          roles: ["developer"]
        },
        {
          name: "Circle Economy",
          url: "http://www.circle-economy.com/",
          description: "empower businesses, cities and nations to put the circular economy into action.",
          stack: [
            tech.scala,
            tech.akkahttp,
            tech.react, 
          ],
          roles: ["developer", "architect"]
        }
      ],
    },
    {
      name: "Finance and blockchain",
      projects: [
        {
          name: "cere.network",
          url: "https://cere.network/",
          description: "Introducing DaaS (Decentralized) Data-as-a-Service Discover the power of decentralized data and accelerate your applications into Web3 with the Cere Decentralized Data Cloud (DDC) and ready-to-use Cere Tools and Services",
          stack: [
            tech.typescript,
            tech.reactnative,
            tech.android,
            tech.kotlin,
          ],
          roles: ["developer"],
        },
        {
          name: "Cherrisk",
          url: "https://www.cherrisk.com/",
          description: "is a digital insurance company that offers a new approach to insurance. We believe that insurance should be simple, transparent, and fair.",
          stack: [
            tech.scala,
            tech.cats,
            tech.mssql,
          ],
          roles: ["developer"],
        }
      ]
    },
    {
      name: "Content management",
      projects: [
        {
          name: "Loan application for Croatian Postal Bank, EMC success story available on request",
          roles: ["developer"],
          stack: [tech.documentum, tech.java],
        },
        {
          name:"Digital archive for Municipal of Rijeka",
          roles: ["developer"],
          stack: [tech.documentum, tech.java],
        },
        {
          name: "Digital archive for HEP (national electricity company)",
          roles: ["developer"],
          stack: [tech.documentum, tech.java],
        },
        {
          name: "Invoice processing for Tisak (largest kiosk retail chain in Croatia)",
          roles: ["developer"],
          stack: [tech.documentum, tech.java],
        },
      ],
    }
  ];
  const firstDomains = domains.slice(0, 3);
  const secondDomains = domains.slice(3, 6);
</script>

<style>
  .pantone {
    background-color: rgb(25, 76, 125);
    color: white;
  }

  .mihogreen {
    background-color: rgb(33, 132, 39);
    color: white;
  }
</style>

<main>
  <GoogleAnalytics properties={['G-L7ZW6MJN9Z']} />
  <header class="section">
      <div style="display:flex; justify-content:center;">
        <h1 style="text-transform: uppercase;font-size: 2em;text-align:center;">
          &#8532 <br/>fullstack functional programming
        </h1>
      </div>
  </header>
  <section>
    <div class="container">
      <div style="display:flex;justify-content:center;margin-bottom: 2em;"><h1 class="title">Previous projects</h1></div>
      <div class="tile is-ancestor is-vertical">          
          <div class="tile is-parent">
            <div class="tile">
              {#each firstDomains as domain, i}
              <div class="tile is-parent">
                <article class="tile is-child">
                  <p class="title" style="text-align:center">{domain.name}</p>
                {#if domain.projects}
                  {#each domain.projects as project}
                    <p>
                      <Project {project}/>
                    </p>
                  {/each}
                {/if}
                </article>
              </div>
              {/each}
            </div>
          </div>
        <div class="tile is-parent">
          {#each secondDomains as domain, i}
          <div class="tile is-parent">
            <article class="tile is-child">
              <p class="title" style="text-align:center">{domain.name}</p>
              <div class="content">
                {#if domain.projects}
                  {#each domain.projects as project}
                    <p>
                      <Project {project}/>
                    </p>
                  {/each}
                {/if}
              </div>
            </article>
          </div>
          {/each}
        </div>
      </div>
      <div class="tile">
        <div class="tile is-parent">
        <article class="tile is-child">
          <p class="title" style="text-align:center">Frontend</p>
          <div class="content">
          <table>
            <tr>
            <td>Mobile frameworks</td>
            <td style="display:flex">
              {#each [tech.reactnative, tech.android] as tech}
                <Tech {tech} />
              {/each}
            </td>
            </tr>
            <tr>
              <td>Web frameworks</td>
              <td style="display:flex">
              {#each [tech.react, tech.svelte] as tech}
                <Tech {tech} />
              {/each}
              </td>
            </tr>
            <tr>
              <td>Languages</td>
              <td style="display:flex">
                {#each [tech.flow, tech.typescript, tech.scalajs] as tech}
                  <Tech {tech} />
                {/each}
              </td>
            </tr>
          </table>
          </div>
        </article>
        </div>
        <div class="tile is-parent">
        <article class="tile is-child">
          <p class="title" style="text-align:center">Backend</p>
          <div class="content">
            <table>
              <tr>
              <td>Servers</td>
              <td style="display:flex">
                {#each [tech.play, tech.spray, tech.ziohttp] as tech}
                  <Tech {tech} />
                {/each}
              </td>
              </tr>
              <tr>
                <td>Databases</td>
                <td style="display:flex">
                {#each [tech.postgres, tech.mongodb] as tech}
                  <Tech {tech} />
                {/each}
                </td>
              </tr>
              <tr>
                <td>Cloud providers</td>
                <td style="display:flex">
                  {#each [tech.amazon, tech.vercel] as tech}
                    <Tech {tech} />
                  {/each}
                </td>
              </tr>
            </table>
          </div>
        </article>
        </div>
      </div>
    </div>
  </section>

  <footer class="footer">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2>2/3, obrt za modalno programiranje</h2>
          <address>
            <i class="fas fa-address-card" />
            Biokovska ulica 56, 10000 Zagreb, Croatia
          </address>
          <a href="mailto: rudolf.markulin@protonmail.com"><i
              class="far fa-envelope" />
            rudolf.markulin@protonmail.com</a>
          <br />
          <a href="tel:+385992536939"><i class="fas fa-phone" />
            385993778799</a>
        </div>
      </div>
    </div>
  </footer>
</main>
